import get from 'lodash/get';

export const getErrorCodeConvertor = (t, fallbackMessage, fallbackParameters) => action => {
  const error = get(action, 'reason.cause.error');
  if (error && error.errorCode) {
    const generatedErrorMessage = t(error.errorCode, error.parameters);
    if (generatedErrorMessage !== error.errorCode) {
      return generatedErrorMessage;
    }
  }
  return t(fallbackMessage, fallbackParameters);
};
